import { createAction, props } from '@ngrx/store';

import { DetectionLabel } from '../../models/detection-label';

export const loadDetectionLabels = createAction(
  '[Detection Labels] Load',
);

export const loadDetectionLabelsSuccess = createAction(
  '[Detection Labels API] Load Success',
  props<{ labels: DetectionLabel[] }>(),
);

export const loadDetectionLabelsFailure = createAction(
  '[Detection Labels API] Load Failure',
  props<{ error: unknown }>(),
);
